import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';
import {
  useLogout,
  useParticipant,
  useTeamInfo,
  useTeamraiserConfig,
} from '@frx/frx-react-context';
import { useLowercaseQueryString } from '../../hooks';
import { useAppProvider } from '../../context';

export const DonationHeader = () => {
  const {
    queryStrings: { proxy_type: PROXY_TYPE, fr_id, proxy_id },
  } = useLowercaseQueryString();

  const {
    data: { user },
  } = useAppProvider();
  const {
    data: { teamraiserConfig: { publicName } = { publicName: '' } } = {},
  } = useTeamraiserConfig();

  const { data: participant } = useParticipant({
    cons_id: PROXY_TYPE !== '21' ? proxy_id : undefined,
    fr_id,
    list_page_size: 1,
  });

  const { data: teamInfo } = useTeamInfo({
    fr_id,
    team_id: PROXY_TYPE === '22' ? proxy_id : undefined,
  });

  const userName = participant
    ? participant?.name?.screenname ||
      `${participant?.name.first} ${participant?.name?.last}`
    : '';

  const { mutate: logout } = useLogout();
  const handleLogout = () => logout();

  const onBehalfOf = teamInfo?.name || userName || publicName;

  return (
    <VStack spacing={6} align="left">
      <Box>
        <Heading as="h1" fontWeight="regular" color="brand.primary.swatch1">
          Thanks to you, families never receive a bill from St.&nbsp;Jude
        </Heading>
      </Box>

      {user?.name && (
        <Box>
          <Text>
            You are logged in as{' '}
            <strong>{`${user?.name?.first} ${user?.name?.last}`}</strong>
          </Text>
          <Text>
            Not you?{' '}
            <Button variant="link" colorScheme="blue" onClick={handleLogout}>
              Logout
            </Button>
          </Text>
        </Box>
      )}

      <Box>
        <Text>Your donation on behalf of</Text>
        <Text fontSize="3xl">{onBehalfOf}</Text>
      </Box>

      {publicName && PROXY_TYPE !== '21' && (
        <Box>
          <Text>Participating in</Text>
          <Text fontSize="3xl">{publicName}</Text>
        </Box>
      )}
    </VStack>
  );
};
